import React, { useState } from 'react'
import Select from 'react-select'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'

import { acceptExtensions, IMAGE_MODULE } from '../../../../util/constant'
import DeleteIcon from '../../../../assets/img/svg/delete-icon.svg'
import AddIcon from '../../../../assets/img/svg/add-icon.svg'

import DropzoneController from '../../../dropzone'
import DeletePopup from '../../../deletePopup'

const GetReportForm = ({ errors, category }) => {
  const [deleteId, setDeleteId] = useState(null)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)

  const { control, trigger, watch } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'reports'
  })

  const openDeleteModal = (_id) => {
    setDeleteId(_id)
    setIsDeleteModalOpen(!isDeleteModalOpen)
  }

  const onHandleDelete = () => {
    if (deleteId !== null) {
      remove(deleteId)
    }
    openDeleteModal(null)
  }

  return (
    <div className='report_form_wrap'>
      {fields.map((field, index) => (
        <div className="report_form_data card common_card_div" key={index}>
          <div className="report_header_row">
            {fields.length - 1 === index ? (
              <div
                className="icon_box_div add_icon"
                onClick={() => append({ cleaning_reports_category: null, title: '', description: '', images: [] })}
              >
                <img src={AddIcon} alt="upload" width={24} />
              </div>
            ) : (
              <div className="icon_box_div delete_icon" onClick={() => openDeleteModal(index)}>
                <img src={DeleteIcon} alt="upload" width={17} />
              </div>
            )}
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label>Category</label>
              <Controller
                name={`reports.${index}.cleaning_reports_category`}
                control={control}
                defaultValue={field.category || ''}
                render={({ field, fieldState }) => (
                  <>
                    <Select
                      {...field}
                      className={`react-selectcomponent ${errors?.type ? 'error-input' : ''}`}
                      getOptionLabel={(option) => `${option.category}`}
                      getOptionValue={(option) => `${option.cleaning_reports_category_id}`}
                      options={category}
                      isClearable
                      isSearchable={true}
                      placeholder={`Select Category`}
                      classNamePrefix="select_kanakku"
                      defaultValue={''}
                      onChange={async (val) => {
                        field.onChange(val)
                        await trigger(`reports.${index}.title`)
                        await trigger(`reports.${index}.description`)
                      }}
                    />
                    <small className="fw-500">{fieldState?.error?.message}</small>
                  </>
                )}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label>Issues Name {watch(`reports.${index}.cleaning_reports_category`) && <span className="text-danger"> *</span>}</label>
              <Controller
                name={`reports.${index}.title`}
                control={control}
                defaultValue={field.title || ''}
                render={({ field: { value, onChange }, fieldState }) => (
                  <>
                    <input
                      className="form-control"
                      value={value}
                      type="text"
                      placeholder="Enter Issue Name"
                      onChange={async (val) => {
                        onChange(val)
                        await trigger(`reports.${index}.title`)
                        await trigger(`reports.${index}.cleaning_reports_category`)
                        await trigger(`reports.${index}.description`)
                      }}
                    />
                    <small>{fieldState?.error?.message}</small>
                  </>
                )}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label>Describe Issue {watch(`reports.${index}.cleaning_reports_category`) && <span className="text-danger"> *</span>}</label>
              <Controller
                name={`reports.${index}.description`}
                control={control}
                defaultValue={field.description || ''}
                render={({ field: { value, onChange }, fieldState }) => (
                  <>
                    <textarea
                      className={`form-control ${fieldState?.error?.message ? 'error-input' : ''}`}
                      type="text"
                      value={value || ''}
                      onChange={async (val) => {
                        onChange(val)
                        await trigger(`reports.${index}.title`)
                        await trigger(`reports.${index}.cleaning_reports_category`)
                        await trigger(`reports.${index}.description`)
                      }}
                      placeholder="Describe Issue"
                      autoComplete="false"
                      rows="3"
                    ></textarea>
                    <small>{fieldState?.error?.message}</small>
                  </>
                )}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label>Evidence Photos</label>
              <DropzoneController
                name={`reports.${index}.images`}
                maxFiles={10}
                acceptExtensions={acceptExtensions}
                control={control}
                files={watch(`reports.${index}.images`)}
                module={IMAGE_MODULE.CLEANING_REPORTS}
                isEditImage={true}
                isAddMode={true}
              />
            </div>
          </div>
          {isDeleteModalOpen && (
            <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={() => openDeleteModal(null)}>
              <div className="multi_btn_div">
                <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsDeleteModalOpen(false)}>
                  Cancel
                </button>
                <button type="button" className="btn btn-danger common-field-btn w-100" onClick={() => onHandleDelete()}>
                  Delete
                </button>
              </div>
            </DeletePopup>
          )}
        </div>
      ))}
    </div>
  )
}

export default GetReportForm
